/*
 * API
 * needLoading: { Boolean } 是否需要请求加载时的loading组件
 */
import service from '@/utils/request'

const info = params => {
  return service.get('/api/userinfo', { params: params, needLoading: true })
}

const purchase = body => {
  return service.post('/api/purchase', body, { needLoading: true })
}

const history = params => {
  return service.get('/api/history', {needLoading: true })
}

const policyCheck = body => {
  return service.post('/api/policy_check', body, { needLoading: true, opacity: true })
}

const googlePolicyCheck = body => {
  return service.post('/api/google_analytics_check', body, { needLoading: true, opacity: true })
}

export default {
  info,
  purchase,
  history,
  policyCheck,
  googlePolicyCheck
}



// WEBPACK FOOTER //
// ./src/api/index.js